import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchContactInfo, fetchPortfolio, fetchWebsiteContent, fetchSettings } from '../api';

const WebsiteDataContext = createContext(null);

export const useWebsiteData = () => useContext(WebsiteDataContext);

export const WebsiteDataProvider = ({ children }) => {
  const [contact, setContact] = useState(null);
  const [portfolio, setPortfolio] = useState([]);
  const [content, setContent] = useState({});
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  const refreshData = async () => {
    try {
      const [contactData, portfolioData, contentData, settingsData] = await Promise.all([
        fetchContactInfo().catch(() => null),
        fetchPortfolio({ status: 'active' }).catch(() => []),
        fetchWebsiteContent().catch(() => ({})),
        fetchSettings().catch(() => ({})),
      ]);
      if (contactData) setContact(contactData);
      if (portfolioData) setPortfolio(portfolioData);
      if (contentData) setContent(contentData);
      if (settingsData) setSettings(settingsData);
    } catch (err) {
      console.warn('Failed to fetch dynamic data, using defaults');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refreshData(); }, []);

  return (
    <WebsiteDataContext.Provider value={{ contact, portfolio, content, settings, loading, refreshData }}>
      {children}
    </WebsiteDataContext.Provider>
  );
};
